require('../../../modules/es.array.sort');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').sort;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/sort.js
// module id = 601
// module chunks = 0 1